<template>
  <div
    class="main ljb-x-padding">
    <p
      :class="{'ljb-border':!item.noBorder}"
      class="ljb-item_cell ljb-y-padding"
      @click="chooseFn">
      <span class="left ljb-text">{{ item.type }}</span>
      <span
        :class="{nextArrow:item.showNextArrow}"
        class="right ljb-text">{{ item.value }}</span>
    </p>

  </div>
</template>

<script>
export default {
  name: 'LjbItem',
  props: {
    item: {
      type: Object,
      default: function () {
        return ''
      }
    }
  },
  methods: {
    chooseFn () {
      this.$emit('chooseFn')
    }
  }
}
</script>

<style lang="scss" scoped>
  .main {
    background: #fff;
  }

  .no-border {
    border: none;
  }
  .right {

    color: #999;
    display: inline-block;
    &.nextArrow {
      background: url('https://cdn.51ljb.cn/ljb-arrow_next.png') no-repeat right;
      background-size: 6px 10px;
      padding-right: 11px;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/LjbItem.vue